const iconType = (category) => {
    if (!category) return undefined;
    switch (category.toLowerCase()) {
        case 'local':
            return 'HomeWork';
        case 'holding':
            return 'Suitcase';
        case 'top 10':
            return 'Top10New';
        default:
            return undefined;
    }
};

export default iconType;
